// extracted by mini-css-extract-plugin
export var bounce = "ButtonClose-module--bounce--dd4ca";
export var button = "ButtonClose-module--button--1206e";
export var dotMoveLeft = "ButtonClose-module--dot-move-left--15ee7";
export var dotMoveRight = "ButtonClose-module--dot-move-right--7085f";
export var gradient = "ButtonClose-module--gradient--7ccab";
export var separatorWidth = "ButtonClose-module--separator-width--f29f9";